<template>
  <v-container class="pa-0">
    <div class="search-panel pa-2 grey lighten-3">
      <v-btn
        style="text-transform: none"
        plain
        rounded
        color="grey darken-3"
        @click="isDatePicker = true"
      >
        <v-icon>mdi-filter</v-icon>
        Filter
      </v-btn>

      <v-chip
        v-if="isFiltering"
        color="info"
        @click:close="clearFilter('date')"
        outlined
        close
        class="white--text"
        >{{ moment(date.from).format("MMM DD, YYYY") }} -
        {{ moment(date.to).format("MMM DD, YYYY") }}</v-chip
      >

      <v-chip
        v-if="this.params.shop_id != null && filter_shop != ''"
        color="info"
        @click:close="clearFilter('shop')"
        outlined
        close
        class="white--text ml-1"
        >{{ filter_shop }}</v-chip
      >

      <v-dialog
        v-model="isDatePicker"
        fullscreen
        hide-overlay
        persistent
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark flat style="border-radius: 0px" color="primary">
            <v-btn icon dark @click="isDatePicker = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Filter</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="applyFilter"> Apply </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader class="mt-4">
            <v-subheader>Date Between</v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-dialog ref="dialog1" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      class="pr-1"
                      label="From"
                      placeholder="select from date"
                      outlined
                      readonly
                      dense
                      v-bind="attrs"
                      v-on="on"
                      v-model="date.from"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date.from" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        $refs.dialog1.save(date.from);
                        date.from = null;
                      "
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog1.save(date.from)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-list-item-content>
              <v-list-item-content>
                <v-dialog ref="dialog2" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      class="pl-1"
                      label="To"
                      placeholder="select to date"
                      outlined
                      readonly
                      dense
                      v-bind="attrs"
                      v-on="on"
                      v-model="date.to"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date.to" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        $refs.dialog2.save(date.to);
                        date.to = null;
                      "
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog2.save(date.to)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-list-item-content>
            </v-list-item>

            <v-subheader>Sales by Shop</v-subheader>
            <v-list-item>
              <v-list-item-content>
                <v-autocomplete
                  v-model="params.shop_id"
                  :items="shops"
                  label="select shop"
                  dense
                  clearable
                  solo
                  flat
                  outlined
                  item-text="name"
                  item-value="id"
                >
                </v-autocomplete>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-dialog>
    </div>

    <v-skeleton-loader
      class="pt-16"
      v-if="!isLoaded"
      type="list-item-two-line, divider, list-item-two-line, divider,list-item-two-line,divider,list-item-two-line,divider"
    ></v-skeleton-loader>

    <v-container
      class="pt-16 mt-16"
      v-if="sales.length == 0 && isLoaded && !isLoading"
    >
      <div align="center">
        <v-img src="../assets/inbox.png" width="128px"></v-img>
        <h5 class="pt-3 subtitle-2 grey--text text--darken-2">
          Sorry, No data found
        </h5>
      </div>
    </v-container>

    <v-container v-if="isLoaded" class="pt-16">
      <v-row>
        <v-col
          cols="12 text-left pb-0"
          style="padding-bottom: 14px !important; padding-top: 16px !important"
        >
          <h5 class="caption grey--text text--darken-2 text-center" style="">
            <b>Total {{ sales.length }} Sales</b>
          </h5>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-if="isLoaded" class="pt-2">
      <v-row v-ripple v-for="sale in sales" :key="sale.id">
        <v-col cols="12 text-left pb-0">
          <h5 class="caption grey--text">
            {{ moment(sale.date).format("YYYY MMM DD, h:mm A") }}
          </h5>
          <h5 class="subtitle-1">{{ sale.shop.name }}</h5>
          <h5
            class="caption grey--text text--darken-2"
            style="line-height: 19px"
          >
            {{ sale.shop.area.name }},
            {{ sale.shop.area.village.taluk.district.name }}
          </h5>
        </v-col>
        <v-col cols="8">
          <h5 class="subtitle-2">
            {{ sale.transaction.product.product.name }}
          </h5>
          <h5 class="caption">
            Colour : {{ sale.transaction.product.colour.colour }} | Size :
            {{ sale.transaction.product.size.size }}
          </h5>
        </v-col>
        <v-col cols="4" class="text-right">
          <h5 class="caption grey--text">MRP</h5>
          <h5 class="subtitle-1 primary--text">
            ₹ {{ sale.transaction.product.mrp }}
          </h5>
        </v-col>
      </v-row>
    </v-container>

    <div v-if="isLoading" class="text-center pt-2 pb-2">
      <v-progress-circular
        :width="3"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>

    <v-snackbar v-model="snackbar" color="error" timeout="2500"
      >{{ snack_message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      snackbar: false,
      shops: [],
      filter_shop: "",
      snack_message: "Internal server error",
      isFiltering: true,
      isDatePicker: false,
      isLoading: false,
      isLoaded: false,
      modal: false,
      isBottom: false,
      overlay: false,
      total_count: 0,
      date: {
        from: this.moment(new Date()).format("YYYY-MM-DD"),
        to: this.moment(new Date()).format("YYYY-MM-DD"),
      },
      params: {
        page_size: 1000,
        database_offset: 0,
        shop_id: 0,
        filter: {
          date: [
            this.moment(new Date()).format("YYYY-MM-DD"),
            this.moment(new Date()).format("YYYY-MM-DD"),
          ],
        },
      },
      sales: [],
    };
  },
  created() {
    window.addEventListener("scroll", () => {
      this.isBottom = this.bottomVisible();
    });
    this.params.shop_id = this.$route.params.id;
    this.fetchSales();

    //fetch Shops for filter
    this.$api.getShops({}).then(
      (response) => {
        if (response.data.status == "success") {
          this.shops = response.data.shops;
          if (this.params.shop_id > 0) {
            this.filter_shop = this.shops.filter(
              (x) => x.id == this.params.shop_id
            )[0].name;
          } else {
            this.filter_shop = "";
          }
        } else {
          this.shops = [];
        }
      },
      (error) => {
        console.log(error);
        this.shops = [];
      }
    );
  },
  mounted() {
    this.$root.$on("exportData", this.exportData);
  },
  watch: {
    isBottom(isBottom) {
      if (
        isBottom &&
        this.params.database_offset + this.params.page_size < this.total_count
      ) {
        this.isLoading = true;
        this.params.database_offset += this.params.page_size;
        this.fetchSales();
      }
    },
  },
  methods: {
    applyFilter() {
      if (this.date.from == null && this.date.to == null) {
        this.isFiltering = false;
        this.params.filter.date = null;
      } else if (
        (this.date.from != null && this.date.to == null) ||
        (this.date.to != null && this.date.from == null)
      ) {
        this.params.filter.date = null;
        this.isFiltering = false;
        this.snackbar = true;
        this.snack_message = "Please select valid date range";
        return false;
      } else {
        this.isFiltering = true;
        this.params.filter.date = [this.date.from, this.date.to];
      }
      if (this.params.shop_id > 0) {
        this.filter_shop = this.shops.filter(
          (x) => x.id == this.params.shop_id
        )[0].name;
      } else {
        this.filter_shop = "";
      }
      this.isDatePicker = false;
      this.isLoaded = false;
      this.sales = [];
      this.params.page_size = 1000;
      this.params.database_offset = 0;
      this.fetchSales();
    },

    exportData() {
      if (this.overlay) return false;
      this.overlay = true;
      this.$api.getSalesexport(this.params).then(
        (response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Retailer Sales.xlsx");
          document.body.appendChild(link);
          link.click();
          this.overlay = false;
        },
        (error) => {
          console.error(error);
          this.overlay = false;
        }
      );
    },

    clearFilter(role) {
      if (role == "shop") {
        this.params.shop_id = null;
      } else {
        this.isFiltering = false;
        this.date.from = null;
        this.date.to = null;
        this.params.filter.date = null;
      }
      this.isLoaded = false;
      this.sales = [];
      this.params.page_size = 10;
      this.params.database_offset = 0;
      this.fetchSales();
    },

    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    fetchSales() {
      this.$api.getSales(this.params).then(
        (response) => {
          if (response.data.status == "success") {
            this.sales.push(...response.data.sales);
            this.total_count = response.data.count;
            this.isLoaded = true;
            this.isLoading = false;
          }
        },
        (error) => {
          console.log(error);
          this.isLoaded = true;
          this.isLoading = false;
          this.snackbar = true;
        }
      );
    },
  },
  beforeDestroy() {
    this.$root.$off("exportData", this.exportData);
  },
  beforeUnmount() {
    window.removeEventListener("scroll");
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name == "Sales by Shop") {
        vm.params.shop_id = 0;
        vm.filter_shop = "";
        vm.isLoaded = false;
        vm.sales = [];
        vm.fetchSales();
      }
    });
  },
};
</script>
<style scoped>
.row {
  border-bottom: solid 1px #f1f1f1;
}
.v-text-field--outlined >>> fieldset {
  border: solid 1px rgba(0, 0, 0, 0.15);
}
.v-subheader {
  height: auto !important;
}
.search-panel {
  max-height: 56px;
  overflow-x: auto;
  white-space: nowrap;
}
</style>
